import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from '../../shared/services/payment.service';
import { OpenSnackBarService } from '../../shared/services/snackBar.service';

@Component({
  selector: 'app-payment-handling',
  templateUrl: './payment-handling.component.html',
  styleUrls: ['./payment-handling.component.scss'],
  standalone: true,
  imports: []
})
export class PaymentHandlingComponent implements OnInit {
  // tap_id=chg_TS07A4220250906w0XL1105375&
  redirect_target: string = '';
  constructor(private route: ActivatedRoute,
    private paymentService: PaymentService,
    private router: Router,
    private openSnackBarService: OpenSnackBarService,
  ) {
    this.route.queryParams.subscribe(params => {
      console.log("params", params);
      
      const chargeId = params['merchant_order_id'];
      this.redirect_target = localStorage.getItem('redirect_target');
      localStorage.removeItem('redirect_target');
      this.verifyPayment(chargeId);
    });
  }

  ngOnInit() {
  }

  verifyPayment(chargeId: string) {
    this.paymentService.verifyPayment(chargeId).subscribe((response: any) => {
      if (response.status === 'CAPTURED') {
        this.openSnackBarService.openSnackBar(
          "success",
          "Payment successfully",
          "top"
        );
      } else if (response.status === 'TOKENIZED') {
        const card = response.saved_card;
        const cardLabel = card ? `${card.brand} •••• ${card.last_four}` : 'Card';
        this.openSnackBarService.openSnackBar(
          "success",
          `${cardLabel} saved successfully`,
          "top"
        );
      } else {
        this.openSnackBarService.openSnackBar("fail", response.error || response.save_card_error || response.status);
      }
      this.router.navigateByUrl(this.redirect_target || 'subscription');
    }
      , (error: any) => {
        // Handle error during payment verification
        this.openSnackBarService.openSnackBar("fail", error.error);
        this.router.navigateByUrl('subscription');
      });
  }
}
